export function sortByOrder<T extends { order: number }>(descending: boolean = false): (a: T, b: T) => number {
	return (a: T, b: T) => {
		if (a.order > b.order) return descending ? -1 : 1;
		if (a.order < b.order) return descending ? 1 : -1;
		return 0;
	};
}
